import { render, staticRenderFns } from "./DashboardPemohon.vue?vue&type=template&id=020a5637&scoped=true&"
import script from "./DashboardPemohon.vue?vue&type=script&lang=js&"
export * from "./DashboardPemohon.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./DashboardPemohon.vue?vue&type=style&index=1&id=020a5637&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a5637",
  null
  
)

export default component.exports